import React, { useEffect, useState } from "react";
import { Badge, Button, Row, Card } from "reactstrap";
import { Colxx, Separator } from "components/common/CustomBootstrap";

import AppLayout from "layout/AppLayout";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axiosClient";
import { useToken } from "auth/useToken";
import { toast } from "react-toastify";
import LoadError from "components/LoadError";
import { currencyFormatter } from "utils/formatter";

const PricesList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  // the search word behind the current list, so Retry repeats it
  const [lastWord, setLastWord] = useState("");
  const [token, setToken] = useToken();

  const onLoadError = () => {
    const message = "Could not load prices. Check your connection and try again.";
    setLoadError(message);
    setLoading(false);
    toast.error(message);
  };

  useEffect(() => {
    let isMounted = true;
    axios
      .get("/api/details/prices", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        if (isMounted) {
          setData(result.data);
          setLoading(false);
        }
      })
      .catch(() => isMounted && onLoadError());
    return () => {
      isMounted = false;
    };
  }, []);

  const navigate = useNavigate();

  const onSearchKey = (e) => {
    if (e.key === "Enter") {
      setLoading(true);
      handleSearch(e.target.value.toLowerCase());
    }
  };

  const handleSearch = (word) => {
    ///
    setLoading(true);
    setLoadError("");
    setLastWord(word);
    axios
      .get(`/api/details/prices?search=${word}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((result) => {
        // console.log(result.data.data);
        setData(result.data);
        setLoading(false);
      })
      .catch(onLoadError);
  };
  return (
    <AppLayout>
      <div className="dashboard-wrapper">
        <Row>
          <Colxx xxs="12">
            <div className="mb-2">
              <h1>Prices List</h1>
              <div className="text-zero top-right-button-container">
                <Button
                  color="primary"
                  className="top-right-button"
                  onClick={() => navigate("add")}
                >
                  Add new
                </Button>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-block d-md-inline-block pt-1">
                <div className="search-sm d-inline-block mb-1 ">
                  <input
                    type="text"
                    name="keyword"
                    id="search"
                    placeholder={"Search"}
                    onKeyPress={(e) => onSearchKey(e)}
                  />
                </div>
              </div>
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <div className="loading" hidden={!loading} />
          {loadError ? (
            <Colxx xxs="12">
              <LoadError
                message={loadError}
                onRetry={() => handleSearch(lastWord)}
                busy={loading}
              />
            </Colxx>
          ) : !loading && data.length === 0 ? (
            <p>List is empty</p>
          ) : (
            data.map((info) => (
              <Colxx xxs="12" key={info._id} className="mb-3">
                <Card className="d-flex flex-row">
                  <div className="pl-2 d-flex flex-grow-1 min-width-zero">
                    <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                      <NavLink to={`${info._id}`} className="w-30 w-sm-100">
                        <p className="list-item-heading mb-1 truncate">
                          {info.module}
                        </p>
                      </NavLink>
                      <p className="w-30 w-sm-50 list-item-heading mb-1 truncate">
                        {info.exam}
                      </p>
                      <p className="w-20 w-sm-50 list-item-heading mb-1 truncate">
                        {currencyFormatter(`${info.priceAmount}`, "UZS")}
                      </p>
                      <div className="w-15 w-sm-100 mb-1">
                        {info.availableOnPos ? (
                          <Badge color="success" pill>
                            On POS
                          </Badge>
                        ) : (
                          <span className="text-muted text-small">
                            Not on POS
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </Card>
              </Colxx>
            ))
          )}
        </Row>
      </div>
    </AppLayout>
  );
};

export default PricesList;
